export const EVENT_RATE_CACHE_STORAGE_KEY = 'eventRateCache';

// packages-small y usb-event-rate-mannager arman los mismos params (misma agencyInfo en
// localStorage) para pedir "circuitos" (type 1) al mismo endpoint. Si el usuario ya está viendo
// esos datos en packages-small y hace click en "Ver más en {región}", no hace falta pedirlos de
// nuevo — se cachean acá justo antes de navegar (ver goToCircuits()) y event-rate-mannager los
// consume una sola vez (los borra apenas los lee) para no arrastrar datos viejos en visitas futuras.
export interface EventRateCache {
  type: number;
  tipoNombre: string;
  regiones: any[];
}
